<script>
import Config from '@/config';
import {mapActions} from 'vuex';
import {wxClose} from '@/libs/util';
import {passwordGzBind} from '@/api';
import {CellGroup, Form, Field, Button, Toast} from 'vant';

export default {
  name: 'PasswordLogin',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      mobile: '',
      password: '',
      loading: false,

      gzBind: false
    };
  },
  created() {
    if (this.$route.query.gzBind) {
      this.gzBind = true;
      window.document.title = '速电通-账号绑定';
    } else {
      window.document.title = '速电通-密码登录';
    }
  },
  computed: {
    rules() {
      return {
        mobile: [
          {required: true, message: '请输入手机号'},
          {pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/, message: '手机号格式错误'}
        ],
        password: [
          {required: true, message: '请输入密码'},
          {
            validator: (value) => {
              return value && value.length >= 6;
            }, message: '请输入正确的密码'
          }
        ]
      };
    },
    buttonText() {
      return this.gzBind ? '绑定' : '登录';
    },
    loadingText() {
      return this.gzBind ? '绑定中...' : '登录中...';
    }
  },
  methods: {
    ...mapActions([
      'handlePasswordLogin'
    ]),
    onSubmit() {
      this.loading = true;
      if (this.gzBind) {
        passwordGzBind(this.$route.query.token, this.mobile, this.password).then(response => {
          if (response.data.code === Config.successCode) {
            Toast.success('绑定成功');
          }
        }).finally(() => {
          this.loading = false;
          wxClose();
        });
      } else {
        this.handlePasswordLogin({mobile: this.mobile, password: this.password}).then(response => {
          if (response.data.code === Config.successCode) {
            this.$router.go(-1);
          }
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    passwordAsyncValidatorMobile(value) {
      return new Promise(resolve => {
        Toast.loading('验证中...');

        setTimeout(() => {
          Toast.clear();
          resolve(/\d{11}/.test(value));
        }, 1000);
      });
    },
    validateFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    toSmsLogin() {
      this.$router.replace({name: 'smsLogin', params: {gzBind: this.gzBind, token: this.$route.query.token}})
    },
    toResetPassword() {
      this.$router.replace({name: 'restPassword', params: {gzBind: this.gzBind, token: this.$route.query.token}})
    }
  }
}
</script>

<template>
  <div class="password-login">
    <img class="logo" alt="速电通" src="../assets/logo.png">
    <van-form validate-first @failed="validateFailed" @submit="onSubmit">
      <van-cell-group>
        <van-field clearable focus name="mobile" type="number" minlength="11" maxlength="11" label="手机号" placeholder="请输入手机号" titleWidth="60px" autocomplete="off" v-model="mobile" :rules="rules.mobile"/>
        <van-field clearable use-button-slot name="password" type="password" minlength="6" maxlength="16" label="密 码" placeholder="请输入密码" titleWidth="60px" autocomplete="off" v-model="password" :rules="rules.password">
          <van-button plain slot="button" color="#009251" size="small" @click="toResetPassword">忘记密码</van-button>
        </van-field>
      </van-cell-group>
      <div class="button">
        <van-button round block color="#009251" native-type="submit" :loading-text="loadingText" :loading="loading">
          {{ buttonText }}
        </van-button>
      </div>
      <div class="sms-login" @click="toSmsLogin">验证码快捷登录</div>
    </van-form>
  </div>
</template>

<style scoped lang="stylus">
.password-login
  text-align center

.password-login .logo
  height 50px
  width 100px
  margin 24px

.password-login .button
  margin 24px 24px 12px 24px

  .van-button
    box-shadow 0 3px 6px 1px rgba(0, 146, 81, 0.41)

.password-login .sms-login
  text-align right
  color #333333
  font-size 14px
  font-weight 500
  padding-right 24px
</style>
